import React from 'react';
import Overlay from 'Components/Overlay/index';
import Moment from 'moment';

export const AirDetails = (props) => (
    <Overlay>
        <div className="bg-white box-shadow ph-20 pv-20 br-100 pr-40">
            <div className="mb-20 tleft header-medium-color fBold fs-18 border-bottom-light pb-10">{props.flightInfo ? 'Flight Info' : 'Tracking Info'}
                <span className="pr-10 fRight curP" id='close' onClick={props.onClose}>x</span> 
            </div>
            <div className="wt-900">
                <div className="flex flex-between ph-10">
                    <div><span>{'Tracking No.: '}</span><span className="fBold">{props.data.track_number}</span></div>
                    <div><span>{'Weight.: '}</span><span className="fBold">{props.data.weight}</span></div>
                    <div><span>{'Route: '}</span><span className="fBold">{(props.data.origin)} {'-'} {props.data.destination}</span></div>
                </div>
            </div>
            {props.flightInfo && <div className="courier-table details-popUp pv-10 ph-10">
                <table cellPadding="0" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>Flight</th>
                            <th>Depart Station</th>
                            <th>Arrival Station</th>
                            <th width="300">Estimated Departure Time</th>
                            <th width="300">Estimated Arrival Time</th>
                            <th width="300">Departure Time</th>
                            <th width="300">Arrival Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(Object.keys(props.data.flight_info) || []).map((el, index) => {
                            const lineItem = props.data.flight_info[el];
                        return(
                            <tr>
                                <td style={{'borderBottom': '1px solid grey'}}>{el}</td>
                                <td style={{'borderBottom': '1px solid grey'}}>{lineItem.depart_station}</td>
                                <td style={{'borderBottom': '1px solid grey'}}>{lineItem.arrival_station}</td>
                                <td style={{'borderBottom': '1px solid grey'}}>{lineItem.plan_depart_time && Moment(lineItem.plan_depart_time).format('DD MMM YYYY HH:mm:ss')}</td>
                                <td style={{'borderBottom': '1px solid grey'}}>{lineItem.plan_arrival_time && Moment(lineItem.plan_arrival_time).format('DD MMM YYYY HH:mm:ss')}</td>
                                <td style={{'borderBottom': '1px solid grey'}}>{lineItem.depart_time && Moment(lineItem.depart_time).format('DD MMM YYYY HH:mm:ss')}</td>
                                <td style={{'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>{lineItem.arrival_time && Moment(lineItem.arrival_time).format('DD MMM YYYY HH:mm:ss')}</td>
                            </tr>
                        )})}
                    </tbody>
                </table>
            </div>}
            {!props.flightInfo && <div className="courier-table details-popUp pv-10 ph-10">
                <table cellPadding="0" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Event</th>
                            <th>Time</th>
                            <th>Location</th>
                            <th>Flight</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(props.data.track_info || []).map((el, index) => {
                        return(
                            <tr>
                                <td style={{'borderBottom': '1px solid grey'}}>{el.status}</td>
                                <td style={{'borderBottom': '1px solid grey'}}>{el.event}</td>
                                <td style={{'borderBottom': '1px solid grey'}}><span className={el.actual_date ? 'green-color fBold': 'orange-color fBold'}>{el.actual_date && Moment(el.actual_date).format('DD MMM YYYY') || (el.plan_date && Moment(el.plan_date).format('DD MMM YYYY'))}</span></td>
                                <td style={{'borderBottom': '1px solid grey'}}>{el.station}</td>
                                <td style={{'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>{el.flight_number}</td>
                            </tr>
                        )})}
                    </tbody>
                </table>
            </div>}
        </div>
    </Overlay>
)